import { useStore } from 'effector-react';
import { NotSupportedError } from 'features/verify/features/error/not-supported-error';
import { errors$ } from 'model/flows/verification.model';
import { h } from 'preact';
import { InvalidPhotoError } from 'features/verify/features/error/invalid-photo-error';

export const PhotoError = () => {
	const errors = useStore(errors$);

	console.log(errors);
	if (
		errors?.includes('document_not_supported') ||
		errors?.includes('country_not_supported')
	) {
		return <NotSupportedError/>;
	}

	return (
		<InvalidPhotoError/>
	);
};
